// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tramDiagram_root_PwK9K {
  background: white;
  border-radius: var(--border-radius);
  overflow: hidden;
  position: relative;
}

.tramDiagram_componentName_IcTyd {
  padding: 42px;
  font-size: 30px;
  color: var(--hsl-blue);
  position: absolute;
}

.tramDiagram_componentName_IcTyd > .tramDiagram_title_NvMUX {
  font-family: GothamRounded-Medium;
}

.tramDiagram_componentName_IcTyd > .tramDiagram_subtitle_XEaDc {
  font-family: GothamRounded-Book;
}

.tramDiagram_diagram_LcRyZ {
  display: block;
}

.tramDiagram_diagram_LcRyZ svg {
  display: block;
  margin: 0 0 0 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tramDiagram/tramDiagram.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".root {\n  background: white;\n  border-radius: var(--border-radius);\n  overflow: hidden;\n  position: relative;\n}\n\n.componentName {\n  padding: 42px;\n  font-size: 30px;\n  color: var(--hsl-blue);\n  position: absolute;\n}\n\n.componentName > .title {\n  font-family: GothamRounded-Medium;\n}\n\n.componentName > .subtitle {\n  font-family: GothamRounded-Book;\n}\n\n.diagram {\n  display: block;\n}\n\n.diagram svg {\n  display: block;\n  margin: 0 0 0 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `tramDiagram_root_PwK9K`,
	"componentName": `tramDiagram_componentName_IcTyd`,
	"title": `tramDiagram_title_NvMUX`,
	"subtitle": `tramDiagram_subtitle_XEaDc`,
	"diagram": `tramDiagram_diagram_LcRyZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
